/*
  import { frequentlyAskedQuestionStore } from '@/services/FrequentlyAskedQuestions/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await frequentlyAskedQuestionStore.dispatch ('getFrequentlyAskedQuestionList', {
      hoaId
    });
  */

  async getFrequentlyAskedQuestionList({}, { hoaID }) {
    console.log('in getFrequentlyAskedQuestionList...' + hoaID)
    try {
      const results = await kms.get(
        `/FrequentlyAskedQuestions/FrequentlyAskedQuestion/List?hoaID=${hoaID}`
      )

      if (isDebug == true)
        console.debug('getFrequentlyAskedQuestionList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The FAQ list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async deleteFrequentlyAskedQuestions({ dispatch }, { frequentlyAskedQuestionID, done }) {
    try {
      const path = `/FrequentlyAskedQuestions/FrequentlyAskedQuestion/${frequentlyAskedQuestionID}?forceDelete=false`

      const results = await kms.delete(path)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results) {
        notifyMessage(`Successfully deleted the frequently asked question.`)
        done()
      } else {
        notifyError('There was a problem deleting the frequently asked question.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem deleting the frequently asked question.`)
      console.error(exception)
    }
  },

  async addFrequentlyAskedQuestion({ dispatch }, { payload, done }) {
    if (isDebug == true) console.debug('...in addFrequentlyAskedQuestion')
    try {
      const results = await kms.post(`/FrequentlyAskedQuestions/FrequentlyAskedQuestion`, {
        hoaID: payload.hoaID,
        question: payload.question,
        answer: payload.answer,
        sortOrder: payload.sortOrder
      })

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.frequentlyAskedQuestionID > 0) {
        notifyMessage(`Successfully added the frequently asked question.`)
        done({ details: results })
      } else {
        notifyError('There was a problem adding this frequently asked question.')
      }
    } catch (exception) {
      notifyError(`There was a problem adding this frequently asked question.`)
      console.error(exception)
    }
  },

  async updateFrequentlyAskedQuestion({ dispatch }, { payload = {}, done }) {
    try {
      const results = await kms.put(`/FrequentlyAskedQuestions/FrequentlyAskedQuestion`, payload)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.frequentlyAskedQuestionID > 0) {
        notifyMessage(`Successfully updated this frequently asked question.`)
        done({ details: results })
      } else {
        notifyError('There was a problem updating this frequently asked question.')
      }
    } catch (exception) {
      notifyError(`There was a problem processing the update for this frequently asked question.`)
      console.error(exception)
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const frequentlyAskedQuestionStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
